"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SocketTaskReadyState;
(function (SocketTaskReadyState) {
    SocketTaskReadyState[SocketTaskReadyState["CONNECTING"] = 0] = "CONNECTING";
    SocketTaskReadyState[SocketTaskReadyState["OPEN"] = 1] = "OPEN";
    SocketTaskReadyState[SocketTaskReadyState["CLOSING"] = 2] = "CLOSING";
    SocketTaskReadyState[SocketTaskReadyState["CLOSED"] = 3] = "CLOSED";
})(SocketTaskReadyState || (SocketTaskReadyState = {}));
class Api {
}
//# sourceMappingURL=BaseApis.js.map